import React from "react";
import RoundDashboard from "../../../../../d3Components/circlearc/RoundDashboard";

const CircleArcHolder = (props) => {
  const { res, typeName } = props;
  const x = res.getPortfolioVami.map((d) => +d.vami);
  const x_last = x[x.length - 1];
  const y = res.getBenchmarkVami.map((d) => +d.vami);
  const y_last = y[y.length - 1];
  const NewData = [];

  const headingSecond = typeName ? typeName : "Benchmark";

  NewData.push(
    { name: "Portfolio", value: x_last, growth: +x_last.toFixed(0) },
    { name: headingSecond, value: y_last, growth: +y_last.toFixed(0) }
  );

  if (
    props.analyzeExistingActive == true &&
    props.clientBacktestData.getPortfolioVami
  ) {
    let last_value = props.clientBacktestData.getPortfolioVami.map(
      (e) => +e.vami
    );
    let val = last_value[last_value.length - 1];

    NewData.push({
      name: "Orginal Portfolio",
      value: val,
      growth: +val.toFixed(0),
    });
  }
  return (
    <div className="col-lg-5 col-md-5 col-sm-12 col-xs-12">
      <h4 className="text-uppercase bold">total growth</h4>
      {NewData.length > 0 ? (
        // style={{ flex: 1, alignSelf: "stretch" }}
        <svg viewBox="0 0 500 300">
          <RoundDashboard width={500} height={300} NewData={NewData} />
        </svg>
      ) : null}
    </div>
  );
};

export default CircleArcHolder;



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/backtest/growth/section2/circleArcHolder.jsx